import { render, staticRenderFns } from "./Speed.vue?vue&type=template&id=0c4c5fc1"
import script from "./Speed.vue?vue&type=script&lang=js"
export * from "./Speed.vue?vue&type=script&lang=js"
import style0 from "./Speed.vue?vue&type=style&index=0&id=0c4c5fc1&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4c5fc1')) {
      api.createRecord('0c4c5fc1', component.options)
    } else {
      api.reload('0c4c5fc1', component.options)
    }
    module.hot.accept("./Speed.vue?vue&type=template&id=0c4c5fc1", function () {
      api.rerender('0c4c5fc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/schedule/Speed.vue"
export default component.exports